import { Subject } from 'rxjs';

export class HasSubscription {
  autoUnsubscribeNotifier = new Subject();
}
